<template>
    <div v-if="isVisible" class="reminder-box">
        {{ text }}
    </div>
</template>

<script setup>
import {ref, onBeforeUnmount, watch} from 'vue';

const props = defineProps({
    text: {
        type: String,
        default: ''
    },
    duration: {
        type: Number,
        default: 2000
    },
    isVisible: {
        type: Boolean,
        default: false
    }
});

const timer = ref(null);

watch(() => props.isVisible, (newVal) => {
    if (newVal) {
        timer.value = setTimeout(() => {
            // 这里可以通过触发自定义事件通知父组件隐藏提示框
            // 例如使用 emits 触发事件
        }, props.duration);
    } else {
        clearTimeout(timer.value);
    }
});

onBeforeUnmount(() => {
    clearTimeout(timer.value);
});
</script>

<style scoped>
.reminder-box {
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: white;
    padding: 10px 20px;
    border-radius: 5px;
    z-index: 1000;
}
</style>
